
    import {defineComponent, reactive} from 'vue'
    import {useRoute} from "vue-router";

    interface State {
        channelType: string; // 家选 承诺100天
        reportLevel: number;
        protectTime: string;
    }
    export default defineComponent({
        name: "ensureServiceExplain",
        setup() {
            let state: State = reactive({
                channelType: '',
                reportLevel: 0,
                protectTime: '90',
            })
            const {query} = useRoute();
            state.channelType = `${query.channelType}` || '';
            state.reportLevel = Number(`${query.reportLevel}`) || 0;
            state.protectTime = state.channelType === 'jiaxuan' ? '100' : '90';
            return {
                state
            }
        },
        methods: {
            goBack(){
                history.go(-1)
            }
        }
    })
